import React from 'react';
import VideoPlayer from './VideoPlayer';
import { useLocation } from 'react-router-dom';

const scenarioData = {
  id: "0eaa050d-9873-41d0-adfb-9c6a5dd6cca4",
  scenarioName: "Неврологи 2025 C1 EPD-CN-CAP. Май 2",
  duration: 138000,
  slides: [
    {
      id: "0191bde7-5a3e-75e1-94f3-057e713d97bd",
      product: "Профиль пациента",
      keyMessage: "patientProfile4_startPage",
      name: "Жить полной жизнью",
      starttime: 0,
      endtime: 5000,
    },
    {
      id: "0191bde8-a21a-78be-b49a-2ba8e322d86a",
      product: "Профиль пациента",
      keyMessage: "patientProfile4_abbotPageStart",
      name: "Круг ассортимент на открытие",
      starttime: 5000,
      endtime: 9551,
    },
    {
      id: "0194a57d-00cd-7681-aacd-7b9cd872a572",
      product: "Бетасерк",
      keyMessage: "Aleksey53Years2025mc1",
      name: "Алексей, 53 года",
      starttime: 9551,
      endtime: 18742,
    },
    {
      id: "0194a57d-0582-7681-a267-71b50cb07ed4",
      product: "Бетасерк",
      keyMessage: "SymptomsVestibular2025mc1",
      name: "Уменьшает симптомы вестибулярного головокружения",
      starttime: 18742,
      endtime: 28834,
    },
    {
      id: "0194a57c-e601-7717-8df5-e81482c8209f",
      product: "Бетасерк",
      keyMessage: "Patients3Noted2025mc1",
      name: "Улучшение отметили 89,4% пациентов",
      starttime: 28834,
      endtime: 38024,
    },
    {
      id: "0194a57c-e863-7681-9084-89489e34dc19",
      product: "Бетасерк",
      keyMessage: "AccelerateVestibular2025mc1",
      name: "Способствует ускорению вестибулярной компенсации",
      starttime: 38024,
      endtime: 47575,
    },
    {
      id: "0194a57c-fa80-7681-9583-0cac9004d594",
      product: "Бетасерк",
      keyMessage: "SymptomsAcceleration2025mc1",
      name: "Бетасерк Лонг 48 мг",
      starttime: 47575,
      endtime: 57126,
    },

    {
      id: "0194a721-e4c2-7b8b-b7c9-f5e125269dc7",
      product: "Феварин",
      keyMessage: "Vladimir31letscreening2025mc1",
      name: "Владимир, 31 год",
      starttime: 57126,
      endtime: 67038,
    },
    {
      id: "0194a722-16af-7bb7-a0dc-a552e685e0ec",
      product: "Феварин",
      keyMessage: "fourTargetsTheDrug2025mc1",
      name: "4 мишени препарата феварин",
      starttime: 67038,
      endtime: 76048,
    },
    {
      id: "0194a721-fd18-7b8b-ba9f-8b8a3281288a",
      product: "Феварин",
      keyMessage: "NeuroinflammationIsaKey22025mc1",
      name: "Развитие ангедонии у пациентов с депрессией",
      starttime: 76048,
      endtime: 85600,
    },
    {
      id: "0194a722-1550-7b8b-acad-f4f34eef456f",
      product: "Феварин",
      keyMessage: "FluvoxamineReducesSymptoms2025mc1",
      name: "Флувоксамин снижает симптомы депрессии и ангедонии",
      starttime: 85600,
      endtime: 95151,
    },
    {
      id: "0194a721-fa0c-7b8b-8805-fb6e04d7298d",
      product: "Феварин",
      keyMessage: "FevarinIsOriginalAntidepressant2025mc1",
      name: "4 эффекта для устранения основных проявлений депрессии",
      starttime: 95151,
      endtime: 104522,
    },
    {
      id: "0194a722-0bdd-7b8b-9116-739c5246ec90",
      product: "Феварин",
      keyMessage: "AnOriginalAntidepressant2025mc1",
      name: "Феварин - оригинальный антидепрессант с 4 эффектами для устранения основных проявлений депрессии",
      starttime: 104522,
      endtime: 114073,
    },

    {
      id: "0194a737-0abe-7cc8-b30d-fb4e624a7723",
      product: "Селектра",
      keyMessage: "Anna27let2025mc1",
      name: "Анна, 27",
      starttime: 114073,
      endtime: 123984,
    },
    {
      id: "0194a737-0881-7cc8-bfd9-5dfc5cff201e",
      product: "Селектра",
      keyMessage: "MultifacetedApproach52025mc1",
      name: "Многогранный подход к терапии",
      starttime: 123984,
      endtime: 132500,
    },
    {
      id: "0191bde7-f742-774c-b278-9f20440d0af5",
      product: "Patient profile",
      keyMessage: "patientProfile4_abbottPage",
      name: "Круг ассортимент на закрытие",
      starttime: 132500,
      endtime: 137500,
    }
  ]
};

const App: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const doctorId = params.get('id');

  return (
      <div>
        <VideoPlayer
            videoUrl="/output_with_slide.mp4"
            scenario={scenarioData}
            doctorId={doctorId || ''}
        />
      </div>
  );
};

export default App;
